import { render, staticRenderFns } from "./coolStudent.vue?vue&type=template&id=556897af&scoped=true&"
import script from "./coolStudent.vue?vue&type=script&lang=js&"
export * from "./coolStudent.vue?vue&type=script&lang=js&"
import style0 from "./coolStudent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./coolStudent.vue?vue&type=style&index=1&id=556897af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556897af",
  null
  
)

export default component.exports